import Helper from "./Helper";

class IeNotification {
  constructor(){
    const notification = document.querySelector('.ie-notification');

    if(notification && Helper.getCookie('ie') == 'accepted'){
      notification.style.display = 'none';
    }
  }
} export default IeNotification;
